
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Suite à la polémique sur les risques de thrombose, plusieurs pays ont
momentanément suspendu l'utilisation de ce vaccin en mars 2021. En date du 4
avril 2021, 222 cas de thromboses atypiques avaient été recensés dans l'Espace
européen (UE, Islande, Norvège et Liechtenstein), sur un total de 34 millions
d'injections.`}</p>
    <p>{`L'Agence européenne des médicaments a examiné 86 cas signalés au 22 mars 2021,
dont 18 mortels. Le 7 avril, elle a reconnu qu'il y avait un lien possible entre
ce vaccin et des cas très rares de caillots sanguins liés à un faible taux de
plaquettes sanguines. Vu cette extrême rareté, elle estime que la balance
bénéfice/risque reste positive. Suite à cette affaire, la Norvège et le Danemark
ont stoppé son utilisation.`}</p>
    <p>{`Après leur commercialisation, les vaccins continuent de faire l’objet d’un suivi
rapproché et d’éventuelles réactions indésirables doivent être signalées. Pour
celui d'AstraZeneca, l'Agence nationale de sécurité du médicament et des
produits de santé
`}<a parentName="p" {...{
        "href": "https://ansm.sante.fr/dossiers-thematiques/covid-19-vaccins/effets-indesirables-lies-aux-vaccins-autorises-contre-la-covid-19-ce-quil-faut-savoir"
      }}>{`(ANSM`}</a>{`,
en France) annonce les effets secondaires très fréquents (au moins une personne
sur dix) suivants: réaction au site d'injection, symptômes pseudo-grippaux
(céphalées, état fébrile, frissons, fatigue, douleurs musculaires ou
articulaires), nausées, malaise. Des vomissements, des diarrhées et de la fièvre
surviennent aussi de façon fréquente (plus d'un cas sur 100).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;